<template>
  <div>
    <md-card class="card-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="isEditing ? '修改服務項目' : '新增服務項目'"></page-title>
        </div>
      </div>
      <div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>名稱</label>
              <md-input v-model="data.name"></md-input>
            </md-field>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>價格</label>
              <md-input v-model="data.price"></md-input>
            </md-field>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised md-danger" @click="goItemList">返回</md-button>
          <md-button class="md-raised md-accent" @click="removeItem">刪除物品</md-button>
        </div>
        <div class="md-layout-item">
          <md-button class="float-right md-raised md-primary" @click="submit">送出</md-button>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import axios from 'axios'
import urls from '@/urls'

export default {
  data () {
    return {
      isEditing: null,
      data: {
        role: {}
      }
    }
  },
  components: {
    PageTitle
  },
  created: function () {
    if (this.$route.params.id !== 'add') {
      this.isEditing = this.$route.params.id
    }
    if (this.isEditing) {
      this.readItem(this.isEditing)
    }
  },
  methods: {
    goItemList () {
      this.$router.push('/item')
    },
    submit: async function () {
      let url
      if (this.isEditing) {
        url = urls({route: 'item', id: this.isEditing})
        await axios.put(url, this.data)
      } else {
        url = urls({route: 'item'})
        await axios.post(url, this.data)
      }
      this.goItemList()
    },
    removeItem: async function () {
      await axios.delete(urls({route: 'item', id: this.isEditing}))
      this.goItemList()
    },
    readItem: async function (itemID) {
      let req = await axios.get(urls({route: 'item', id: this.isEditing}))
      this.data = req.data.data
      this.setItemData({
        id: this.data.id,
        id_alt: this.data.id_alt,
        name: this.data.name
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Item/ItemEdit.vue